import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Background Frame", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Content", -1)
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Health Rules", -1)
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "d-flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          placement: "top",
          content: "Using media background",
          "show-after": 0,
          "hide-after": 0,
          disabled: !_ctx.signageItemLayoutData.useBackgroundMedia
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              class: "signage__color-picker-wrapper",
              prop: "backgroundColor",
              label: "Background Color"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_color_picker, {
                  class: "mt-1",
                  modelValue: _ctx.signageItemLayoutData.backgroundColor,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event)),
                  disabled: _ctx.signageItemLayoutData.useBackgroundMedia
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_form_item, { label: "Use Background Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.useBackgroundMedia,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.useBackgroundMedia) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useBackgroundMedia)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Background Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "true",
                  sizeLimitMB: "300",
                  layoutProperty: "asset1",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "occupancyTitle",
          label: "Occupancy Title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.occupancyTitle,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyTitle) = $event)),
              placeholder: "Occupancy Title",
              maxlength: "200"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "occupancyLimit",
          label: "Occupancy Limit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.occupancyLimit,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyLimit) = $event)),
              placeholder: "Occupancy Limit",
              maxlength: "3"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "occupancyDescription",
          label: "Occupancy Description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.occupancyDescription,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyDescription) = $event)),
              placeholder: "Occupancy Description",
              maxlength: "200"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "occupancyTitleFontColor",
            label: "Occupancy Title Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.occupancyTitleFontColor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyTitleFontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "occupancyLimitFontColor",
            label: "Occupancy Limit Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.occupancyLimitFontColor,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyLimitFontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageItemLayoutData.occupancyRules, (rule, index) => {
            return (_openBlock(), _createBlock(_component_el_form_item, {
              class: _normalizeClass(["m-0", { 'mb-2': index < _ctx.signageItemLayoutData.occupancyRules.length }]),
              key: index,
              prop: "occupancyRules"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.signageItemLayoutData.occupancyRules[index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.signageItemLayoutData.occupancyRules[index]) = $event),
                  placeholder: "Rule",
                  maxlength: "85"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "occupancyRulesBackground",
            label: "Rules Background"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.occupancyRulesBackground,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyRulesBackground) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "occupancyRulesFontColor",
            label: "Rules Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.occupancyRulesFontColor,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyRulesFontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "occupancyRulesImageColor",
            label: "Rules Image Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.occupancyRulesImageColor,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.signageItemLayoutData.occupancyRulesImageColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}